function initProductCarousels(images) {
    const $main = $(".main");
    const $thumbs = $(".thumbs");

    // 1️ Destroy existing carousels if they exist
    if ($main.hasClass("owl-loaded")) $main.trigger("destroy.owl.carousel").removeClass("owl-loaded");
    if ($thumbs.hasClass("owl-loaded")) $thumbs.trigger("destroy.owl.carousel").removeClass("owl-loaded");

    // 2️ Clear and rebuild markup
    $main.empty();
    $thumbs.empty();

    images.forEach((img, i) => {
        $main.append(`<div style="background-image: url('${img.url}');" class="item-box"></div>`);
        $thumbs.append(`<div style="background-image: url('${img.url}');" class="js-product-image item ${i === 0 ? "active" : ""}"></div>`);
    });

    // 3️ Determine slides per breakpoint
    const changeSlide = 4;
    const slide =
        $(window).width() < 600
            ? changeSlide - 1
            : $(window).width() > 999
                ? changeSlide + 1
                : changeSlide;

    // 4️ Initialize both carousels
    $main.owlCarousel({
        nav: true,
        items: 1
    });

    $thumbs.owlCarousel({
        nav: true,
        margin: 15,
        mouseDrag: false,
        touchDrag: true,
        responsive: {
            0: { items: changeSlide - 1, slideBy: changeSlide - 1 },
            600: { items: changeSlide, slideBy: changeSlide },
            1000: { items: changeSlide + 1, slideBy: changeSlide + 1 }
        }
    });

    // 5️ Re-bind events
    bindCarouselEvents($main, $thumbs, slide);
}

function bindCarouselEvents($main, $thumbs, slide) {
    // remove old event handlers
    $(".right, .left, .right-t, .left-t, .js-product-image").off();
    $main.off("translated.owl.carousel");
    $thumbs.off("translated.owl.carousel");

    // main slider navigation and state
    $main.on("translated.owl.carousel", function () {
        $(".right").removeClass("nonr");
        $(".left").removeClass("nonl");

        if ($(".main .owl-next").is(".disabled")) $(".slider .right").addClass("nonr");
        if ($(".main .owl-prev").is(".disabled")) $(".slider .left").addClass("nonl");

        $(".slider-two .item").removeClass("active");
        const c = $(".slider .owl-item.active").index();
        $(".slider-two .item").eq(c).addClass("active");

        const d = Math.ceil((c + 1) / slide) - 1;
        $(".slider-two .owl-dots .owl-dot").eq(d).trigger("click");
    });

    // main navigation buttons
    $(".right").on("click", function () {
        $(".slider .owl-next").trigger("click");
    });
    $(".left").on("click", function () {
        $(".slider .owl-prev").trigger("click");
    });

    // thumbs carousel navigation
    $thumbs.on("translated.owl.carousel", function () {
        $(".right-t").removeClass("nonr-t");
        $(".left-t").removeClass("nonl-t");

        if ($(".thumbs .owl-next").is(".disabled")) $(".slider-two .right-t").addClass("nonr-t");
        if ($(".thumbs .owl-prev").is(".disabled")) $(".slider-two .left-t").addClass("nonl-t");
    });

    $(".right-t").on("click", function () {
        $(".slider-two .owl-next").trigger("click");
    });
    $(".left-t").on("click", function () {
        $(".slider-two .owl-prev").trigger("click");
    });

    // click on thumb
    $(document).on("click", ".js-product-image", function () {
        const index = $(".js-product-image").index(this);
        $(".slider .owl-dots .owl-dot").eq(index).trigger("click");
        $(".js-product-image").removeClass("active");
        $(this).addClass("active");
    });
}

$(document).ready(function () {
    // initial load from Razor model
    const initialImages = $("#product-image-carousel .item-box").map(function () {
        return { url: $(this).css("background-image").replace(/url\(["']?([^"']*)["']?\)/, "$1") };
    }).get();

    initProductCarousels(initialImages);
});